import styled from "styled-components";

export const Capitalize = styled.span`
  text-transform: capitalize;
`;
